import { OrderButtons } from '@trashlab/sitesapp/src/templates/redebins/components/shared/order-buttons';

export const DumpsterRentalsHeroSection = () => {
  return (
    <section className="relative min-h-[400px] flex items-center">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/redebins/images/hero-background.jpg')`,
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/10" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-16">
        {/* Phone Number */}
        <a
          href="tel:952-931-2577"
          className="inline-block text-[#E31837] text-3xl md:text-4xl font-bold mb-4 hover:underline"
        >
          952-931-2577
        </a>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl italic text-white mb-8">
          Order Your Dumpster
        </h1>

        {/* Order Buttons */}
        <OrderButtons />
      </div>
    </section>
  );
};
